let scrollPosition = 0;

export function lockBodyScroll() {
    // Сохраняем текущую позицию скролла
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // Вычисляем ширину скроллбара для компенсации
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Применяем стили для блокировки скролла
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollBarWidth}px`;

    // Для iOS и мобильных браузеров: фиксируем body и сохраняем позицию скролла
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
}

export function unlockBodyScroll() {
    // Убираем стили блокировки
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    // Восстанавливаем позицию скролла
    window.scrollTo(0, scrollPosition);
}
